<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ilXamt/tc-custom/9781526765086.jpg?1705025862513" alt="This image is the cover for the book Dambuster-in-Chief"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dambuster-in-Chief
      </h1>
      <p class="bookDescription body article font2">
        <b>“A fascinating biography of one of the most important figures in Bomber Command during the Second World War.” —History of War</b><br/><br/>Ralph Cochrane was born in 1895 into a distinguished naval family. After joining the Royal Navy, he volunteered in 1915 to serve with the RNAS in airships and was an early winner of the Air Force Cross. In 1918 he transferred to the fledgling RAF and learned to fly, serving in Iraq as a flight commander under “Bomber” Harris. His inter-war career saw him as a squadron commander in Aden before he became the first Chief of Air Staff of the Royal New Zealand Air Force. During the Second World War he served mainly in Bomber Command and commanded 5 Group from early 1943. He formed 617 Squadron and was instrumental in planning the legendary Dambuster Raid, the most spectacular of the War, as well as the sinking of the battleship <i>Tirpitz</i>. An inspirational leader, he trained 5 Group in low level target marking skills.<br/><br/>Post war, Cochrane held a string of senior appointments commanding Transport Command, Flying Training Command and finally as Vice Chief of Air Staff, retiring in 1952. He died in 1977.<br/><br/><b>“A brilliantly researched biography of a fascinating fighter . . . adds a new name to rank alongside Great Britain’s most heroic warriors.” —<i>Argunners </i></b><br/><br/><b>“The Dambusters is one of my absolute favourite stories from WWII . . . and this bio of Cochrane tells the story of an extraordinary man. Brilliant.” —Books Monthly</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Mead
      </h2>
      
      <p class="authorDescription body article">Richard Mead was educated at Marlborough College and Pembroke College, Cambridge. He has written 'General ‘Boy’: The Life of Lieutenant General Sir Frederick Browning' and 'The Last Great Cavalryman: The Life of General Sir Richard McCreery', 'Commander Eighty Army', 'The Men Behind Monty' and 'Commando General – The Life of Sir Robert Laycock', all in print with Pen and Sword Military.  Richard and his wife live in Gloucestershire and he has two grown-up sons.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Aviation
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4912d0b1